import { useState } from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import MoveUserDialog from "../Modal/MoveUserDialog";

export default function ButtonMoveUser({ user, onMoved }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        outline
        size="sm"
        color="primary"
        onClick={() => setIsOpen(true)}
      >
        <FontAwesomeIcon icon={faRightLeft} className="me-1" />
        <FormattedMessage id="Move" />
      </Button>
      {isOpen && (
        <MoveUserDialog
          user={user}
          onClose={() => setIsOpen(false)}
          onMoved={onMoved}
        />
      )}
    </>
  );
}
